export default __webpack_public_path__ + "static/media/Page3_ScMethodology.061907b4.JPG";